/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*
*/

/**
 * @module bulbimage/utils
 */
// import * as $ from 'jquery';

class BulbImageCropUtils {

  // cropperOptions = {
  //   checkCrossOrigin: false,
  //   movable: false,
  //   rotatable: false,
  //   scalable: false,
  //   zoomable: false,
  //   zoomOnTouch: false,
  //   zoomOnWheel: false,
  //   data: null,
  //   minCropBoxWidth: 0,
  //   minCropBoxHeight: 0,
  // };

  originalImage = { element: null as any, blockId: null };

  // newImage = { element: null, blockId: null };

  /**
   * Helper function to indicate whether or not the cropper state is active on an image.
   *
   * @returns {boolean}
   */
  // public isCropperActive(): boolean {
  //   return jQuery('.cropper-container').length > 0;
  // }

  /**
   * Helper function to get the uncropped image asset for a given content block.
   *
   * @param contentBlock The content block containing the image.
   * @param imageIndex The index of the image in the carousel, or null if not applicable.
   * @returns The uncropped image asset if available, otherwise the full image asset.
   */
  public getUncroppedImageAsset(contentBlock: any, imageIndex: number | null): any {
    const block = imageIndex !== null ? contentBlock.carouselImages[imageIndex] : contentBlock;
    return block.uncroppedImageAsset || block.fullImageAsset;
  }

  /**
   * Helper function to create the UIElement that will house the cropper from cropperjs.
   * @param writer
   * @param imageIdAttr
   * @param originalImgSrc
   * @returns {module:engine/view/uielement~UIElement}
   */
  // public createCropperUIElement(writer, imageIdAttr, originalImgSrc, isImageCarousel) {
  //   const uiElement = writer.createUIElement('div', {
  //     class: 'bulb_cropper_wrapper',
  //   }, function (this, domDocument) {
  //     const domElement = this.toDomElement(domDocument);
  //
  //     // Add a fake image here, and then hide the other image.
  //     domElement.innerHTML = `<img image-id="${imageIdAttr}" src="${originalImgSrc}" />`;
  //
  //     return domElement;
  //   });
  //   return uiElement;
  // }

  /**
   * Helper function to initialize the cropper onto the jquery element.
   *
   * @param bulbBlockId block id for the currently selected content-block.
   * @param contentBlock currently selected content-block.
   * @param uncroppedAsset
   * @param imageIndex
   * @returns {*}
   */
  // public initializeCropper(bulbBlockId, contentBlock, uncroppedAsset, imageIndex) {
  //   const $img = this.getCropperInitializedImage(bulbBlockId);
  //
  //   if (contentBlock.blockType !== 'IMAGE_CAROUSEL') {
  //     this.getOriginalImage(bulbBlockId)?.hide();
  //   } else {
  //     this.getCarouselElement(bulbBlockId)?.hide();
  //   }
  //
  //   // If there is a crop rectangle to set here, then let's do it.
  //   if (contentBlock.cropRectangle) {
  //     this.cropperOptions.data = contentBlock.cropRectangle;
  //   }
  //   if (contentBlock.blockType === 'IMAGE_CAROUSEL') {
  //     $('.swiper-container').addClass('cke-cropper-active');
  //     window.dispatchEvent(new CustomEvent('disableSliding'));
  //   }
  //
  //   // Create the scale here.
  //   const scale = $img.width() / uncroppedAsset.width;
  //
  //   // Add the minCropBoxWidth and minCropBoxHeight here, scaled from the assets.
  //   this.cropperOptions.minCropBoxWidth = 100 * scale;
  //   this.cropperOptions.minCropBoxHeight = 100 * scale;
  //
  //   // Initialize the cropper.
  //   return $img.cropper(this.cropperOptions);
  // }

  /**
   * Caching function to help get the original image, this is so that I do not have to keep continually getting it.
   * @param bulbBlockId
   * @returns {*}
   */
  // public getOriginalImage(bulbBlockId) {
  //   const image = (this.originalImage.blockId === bulbBlockId) ? this.originalImage.element
  //     : jQuery(`figure > div > bulb-image > div > > img[image-id="${bulbBlockId}"]`);
  //
  //   // Set the originalImage variable to the element, so we can find it later.
  //   if (image && image.length > 0 && this.originalImage.blockId !== bulbBlockId) {
  //     this.originalImage = {
  //       element: image,
  //       blockId: bulbBlockId,
  //     };
  //   }
  //
  //   return image;
  // }

  /**
   * Caching function to help get the new image, this is so that I do not have to keep continually getting it.
   *
   * @param bulbBlockId
   * @param imageIndex
   * @returns {*}
   */
  // public getCropperInitializedImage(bulbBlockId) {
  //   let image;
  //
  //   if (bulbBlockId === null) {
  //     image = this.newImage.element;
  //   } else {
  //     const imageFigure = jQuery(`figure[bulb-block-id="${bulbBlockId}"]`);
  //
  //     image = (this.newImage.blockId === bulbBlockId) ? this.newImage.element
  //       : imageFigure.find('.bulb_cropper_wrapper').find('img');
  //
  //     // Set the newImage variable to the element, so we can find it later.
  //     if (image.length > 0 && this.newImage.blockId !== bulbBlockId) {
  //       this.newImage = {
  //         element: image,
  //         blockId: bulbBlockId,
  //       };
  //     }
  //   }
  //
  //   return image;
  // }

  // public createSelectionChangeEvent(editor, writer, contentBlock, editingDocument, modelElement, cropperWrapper) {
  //   editingDocument.on('selectionChange', (evt, data) => {
  //     window.dispatchEvent(new CustomEvent('resetCropButtonStatus'));
  //
  //     if (contentBlock.blockType === 'IMAGE_CAROUSEL') {
  //       this.cleanCropperOptionsAndData(contentBlock.id);
  //     } else {
  //       this.cleanCropperElements(writer, contentBlock.id, cropperWrapper);
  //     }
  //   });
  // }

  // public sendCropperEvent(writer, blockId, cropperWrapper, imageIndex, editor) {
  //   // This crop data scales based on image size, so it is exactly what we want.
  //   const cropData = this.getCropperInitializedImage(blockId).cropper('getData', 'rounded');
  //
  //   // Create the patch to send to the client-side, to be sent to the server.
  //   const imagePatch = {
  //     cropRectangle: {
  //       x: cropData.x, y: cropData.y, width: cropData.width, height: cropData.height,
  //     },
  //     selectedImageIndex: undefined,
  //
  //   };
  //
  //   // If it's an imageCarousel then we just need to clean the cropper data up & remove the cropper. Not replace/restore
  //   // any of the previous image elements and such.
  //   if (imageIndex === null) {
  //     // Clean the cropper elements, and then send the event.
  //     this.cleanCropperElements(writer, blockId, cropperWrapper);
  //   } else {
  //     imagePatch.selectedImageIndex = imageIndex;
  //     this.cleanCropperOptionsAndData(blockId);
  //   }
  //
  //   const bulbCropImageEvent = new CustomEvent('bulbCropImage', {
  //     detail: {
  //       imagePatch, blockId, editor,
  //     },
  //   });
  //   return window.dispatchEvent(bulbCropImageEvent);
  // }

  /**
   * Helper function to clean the cropper element, so the new element can come into play.
   * @param writer
   * @param blockId
   * @param cropperWrapper
   * @param isImageCarousel
   */
  // public cleanCropperElements(writer, blockId, cropperWrapper, isImageCarousel = false) {
  //   // Remove the cropper wrapper & unhide the original element.
  //   const originalElement = this.getOriginalImage(blockId);
  //   this.cleanCropperOptionsAndData(blockId);
  //   writer.remove(cropperWrapper);
  //   // Remove the element from the DOM without another change, and show the original element.
  //   $('.cropper-container').remove();
  //   originalElement?.show();
  //   if (isImageCarousel) {
  //     this.getCarouselElement(blockId)?.show();
  //   }
  // }

  /**
   * Get Original carousel element.
   *
   * @param blockId Id of block.
   * @returns {*|jQuery|HTMLElement|JQLite}
   */
  // public getCarouselElement(blockId) {
  //   const imageFigure = jQuery(`figure[bulb-block-id="${blockId}"]`);
  //   const searchString = '.swiper-wrapper';
  //   return imageFigure.find(searchString);
  // }

  /**
   * Helper function that cleans the data, to be used after a cropper's data needs to be destroyed.
   */
  // private cleanCropperOptionsAndData(blockId) {
  //   if (this.isCropperActive()) {
  //     if (blockId === null) {
  //       // Destroy the cropper.
  //       const image = this.getCropperInitializedImage(null);
  //
  //       if (image !== null) {
  //         image.cropper('destroy');
  //       }
  //     } else {
  //       this.getCropperInitializedImage(blockId).cropper('destroy');
  //     }
  //   }
  //
  //   // Set the reference to newImage & originalImage back to null, since the element was removed. Also revert back the
  //   // changes that we made to the cropperOptions so a new selection and bunch can be handled.
  //   // @ts-ignore
  //   this.newImage = {};
  //   // @ts-ignore
  //   this.originalImage = {};
  //   this.cropperOptions.data = null;
  //   this.cropperOptions.minCropBoxWidth = 0;
  //   this.cropperOptions.minCropBoxHeight = 0;
  // }
}
export default new BulbImageCropUtils();
